import React from "react"
import {BackgroundImg, Container, HeroSliderSettings as SliderSettings} from "./styled"

export const HeroSliderSettings = SliderSettings

type Props = {
  bgImg?: string
  bgColor?: string
  bgPosition?: string
}

const Hero: React.FC<Props> = ({bgImg, bgColor, children, bgPosition}) => (
  <Container bgColor={!bgImg ? bgColor : undefined}>
    {bgImg && <BackgroundImg imgUrl={bgImg} bgPosition={bgPosition} />}
    {children}
  </Container>
)

export default Hero
